import { useState } from 'react';
import { Title } from 'components/Title';

import BookingCalendarStaff from './BookingCalendarStaff';
export default function StaffcalendarPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="StaffcalendarPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="StaffCalendar"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <div className="">
                    <div><BookingCalendarStaff/></div>
                </div>
            </div>
        </div>
    </div>
</section>
		</main>
	);
}
